import { DealsDepartments } from '@/models/GoldVision/GoldVisionDeal';

import { createAsyncAction } from 'typesafe-actions';

import { GetDealsDataResponse } from '../types';

export type GetGoldVisionDealsRequestPayload = {
  page_number: number;
  lines_per_page: number;
  proposal_id?: number;
  company_ids?: string[] | number[];
  owners?: string[];
  statuses?: string[];
  departments?: number[];
  summary?: string;
  created_from?: string;
  created_to?: string;
};

export type GetDealsDepartmentsResponse = {
  success: boolean;
  data: DealsDepartments[];
};

export type GetGoldVisionDealsSuccessPayload = {
  data: GetDealsDataResponse;
};

export type RefreshGoldVisionDataPayload = {
  gv_client_id: number;
};

export type RefreshGoldVisionDataResponse = {
  success: boolean;
  data: DealsDepartments[];
};

export type UpdateDepartmentsPayload = {
  gold_vision_id: number;
};

export type DonloadExecutionSummaryPayload = {
  transaction_id_list: number[];
};

export const getGoldVisionOpenDeals = createAsyncAction(
  'deals/getGoldVisionOpenDeals/request',
  'deals/getGoldVisionOpenDeals/success',
  'deals/getGoldVisionOpenDeals/failure',
)<
  GetGoldVisionDealsRequestPayload,
  GetGoldVisionDealsSuccessPayload,
  undefined
>();

export const getGoldVisionClosedDeals = createAsyncAction(
  'deals/getGoldVisionClosedDeals/request',
  'deals/getGoldVisionClosedDeals/success',
  'deals/getGoldVisionClosedDeals/failure',
)<
  GetGoldVisionDealsRequestPayload,
  GetGoldVisionDealsSuccessPayload,
  undefined
>();

export const getDealsDepartments = createAsyncAction(
  'deals/getDealsDepartments/request',
  'deals/getDealsDepartments/success',
  'deals/getDealsDepartments/failure',
)<undefined, GetDealsDepartmentsResponse, undefined>();

export const getRefreshGoldVisionData = createAsyncAction(
  'deals/getRefreshGoldVisionData/request',
  'deals/getRefreshGoldVisionData/success',
  'deals/getRefreshGoldVisionData/failure',
)<undefined, RefreshGoldVisionDataResponse, undefined>();

export const getUpdateDepartments = createAsyncAction(
  'deals/getUpdateDepartments/request',
  'deals/getUpdateDepartments/success',
  'deals/getUpdateDepartments/failure',
)<UpdateDepartmentsPayload, undefined, undefined>();

export const downloadExecutionSummaryReport = createAsyncAction(
  'deals/downloadExecutionSummary/request',
  'deals/downloadExecutionSummary/success',
  'deals/downloadExecutionSummary/failure',
)<DonloadExecutionSummaryPayload, undefined, undefined>();
